export const AUTH0_SCOPE = ['openid', 'profile', 'email', 'offline_access']
export const API_RECORD_DATE_FORMAT = 'YYYY-MM-DD'
export const NO_FIRST_MONTH_FALLBACK = '2019-01-01'
export const AGGREGATION_NAME_DELIMITER = '--'
export const ADMISSIBLE_EMAIL_GROUP = 'fintastic.ai'
